import gql from 'graphql-tag';

export const PageFragment = gql`
    fragment Page on PageInfo {
        hasPreviousPage
        hasNextPage
        endCursor
        startCursor
    }
`;